<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle24')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle24') }}</h1>
    <p>{{ $t('artText24-1') }}</p>
    <p>{{ $t('artText24-2') }}</p>
    <p>{{ $t('artText24-3') }}</p>
    <p>{{ $t('artText24-4') }}</p>
    <p>{{ $t('artText24-5') }}</p>
    <p>{{ $t('artText24-6') }}</p>
    <img
      :src="`${staticUrl}/images/blog/DreamFlat_Your_Handy_Room_Blueprint_Maker.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText24-7') }}</p>
    <p>{{ $t('artText24-8') }}</p>
    <p>{{ $t('artText24-9') }}</p>
    <p>{{ $t('artText24-10') }}</p>
    <p>{{ $t('artText24-11') }}</p>
    <p>{{ $t('artText24-12') }}</p>
    <p>{{ $t('artText24-13') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle24')}`,
  ogTitle: `${t('artSeoTitle24')}`,
  description: `${t('artSeoDesc24')}`,
  ogDescription: `${t('artSeoDesc24')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
